import React from 'react';
import Header from './Header';

const Page1 = () => {
  return (
    <div>
      <Header />
      <h1>Page 1</h1>
      <p>This is the content of Page 1.</p>
      {/* <iframe
        src="https://www.youtube.com/results?search_query=your_search_terms"
        width="100%"
        height="600"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe> */}

      <iframe src="https://m.wikipedia.org/wiki/ChatGPT" width="100%" height="600"></iframe>


    </div>
  );
};

export default Page1;
